export const END_OF_WORLD_ISLAND_BONUS_SIZE = 6000
